import React, { useContext } from 'react'
import { MainContext } from './../../contexts/MainContext';

export default function MyCrypto() {
    const mainContext = useContext(MainContext)
    return (
        <div className="my-crypto">
            <div className="balances mb-4">
                <div className="bal">
                    <span>Ethereum balance</span>
                    <span className="amount">{mainContext.balance.ethBalance ? mainContext.balance.ethBalance : '0'} ETH</span>
                </div>
                <div className="bal">
                    <span>USDC  balance (ETH)</span>
                    <span className="amount">$ {mainContext.balance.usdcBalanceEth ? mainContext.balance.usdcBalanceEth : '0'}</span>
                </div>
                <div className="bal">
                    <span>USDC  balance (POLY)</span>
                    <span className="amount">$ {mainContext.balance.usdcBalancePoly ? mainContext.balance.usdcBalancePoly : '0'}</span>
                </div>
                <div className="bal">
                    <span>Mintor balance</span>
                    <span className="amount">{mainContext.balance.minterBalance ? mainContext.balance.minterBalance : '0'} MNTR</span>
                </div>
                <div className="bal">
                    <span>Matic balance</span>
                    <span className="amount">{mainContext.balance.maticBalance ? mainContext.balance.maticBalance : '0'} MATIC</span>
                </div>
            </div>
        </div>
    )
}
